/**
 * Blocks any purchase/checkout trigger carrying data-terms-gate-target until
 * the paired gate's checkbox (data-terms-checkbox, inside the element with
 * that id) is checked. Runs on the document in the capture phase so it sees
 * the click before the trigger's own click/submit handling does — calling
 * stopPropagation() there keeps the event from ever reaching the trigger,
 * which stops both the native form submit and any other click listener
 * already bound directly to that trigger (e.g. the vehicle configurator's
 * own bundle-purchase handler) without needing to change that code.
 */
(function () {
  if (window.__inspectbotTermsGateLoaded) return;
  window.__inspectbotTermsGateLoaded = true;

  function getGate(trigger) {
    var id = trigger.getAttribute('data-terms-gate-target');
    return id ? document.getElementById(id) : null;
  }

  function isAccepted(gate) {
    var checkbox = gate.querySelector('[data-terms-checkbox]');
    return Boolean(checkbox && checkbox.checked);
  }

  function showError(gate) {
    var error = gate.querySelector('[data-terms-error]');
    var checkbox = gate.querySelector('[data-terms-checkbox]');
    if (error) error.hidden = false;
    if (checkbox) checkbox.focus();
  }

  function hideError(gate) {
    var error = gate.querySelector('[data-terms-error]');
    if (error) error.hidden = true;
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches || !event.target.matches('[data-terms-checkbox]')) return;
    var gate = event.target.closest('[data-terms-gate]');
    if (gate && event.target.checked) hideError(gate);
  });

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-terms-gate-target]');
      if (!trigger) return;

      var gate = getGate(trigger);
      if (!gate) return;

      if (!isAccepted(gate)) {
        event.preventDefault();
        event.stopPropagation();
        showError(gate);
      }
    },
    true
  );
})();
